import React from 'react';
import { Gift } from 'lucide-react';
export function BonusSection() {
  const bonuses = [{
    id: 1,
    title: 'BONO #1: El Escudo de las 4 PM (Kit Oficina)',
    desc: 'El momento donde el 90% falla, tú lo tendrás bajo control. Te doy el plan exacto para que el antojo de la tarde se encuentre con una pared.',
    image: 'https://cdn.magicpatterns.com/uploads/bhBTg8ve9SW8oSPCKxbj1u/PORTADA_BONO_1.png'
  }, {
    id: 2,
    title: 'BONO #2: Tinto en Paz (Ritual Sin Azúcar)',
    desc: 'Disfruta tu café colombiano como siempre, pero sin que sea el disparador de una recaída. Recupera el placer del ritual sin el drama de la galleta.',
    image: 'https://cdn.magicpatterns.com/uploads/hL6FJPdxS6CA5KYAiJi1Tn/PORTADA_BONO_2.png'
  }, {
    id: 3,
    title: 'BONO #3: Radar de Azúcar (Cero Engaños)',
    desc: 'Conviértete en una experta detectando el "veneno" escondido en el supermercado. Una guía rápida para mercar en 1 minuto sin que el marketing te engañe.',
    image: 'https://cdn.magicpatterns.com/uploads/bmEdCU5qEVpf1vs9RCFneb/PORTADA_BONO_3.png'
  }];
  return <section className="py-12 bg-white" data-id="element-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-17">
        <div className="text-center mb-10" data-id="element-18">
          <div className="inline-flex items-center gap-2 bg-accent-coral/10 text-accent-coral px-4 py-2 rounded-full font-bold text-sm mb-4" data-id="element-19">
            <Gift className="h-4 w-4" data-id="element-20" />
            <span data-id="element-21">REGALOS EXCLUSIVOS DE LANZAMIENTO</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-secondary" data-id="element-22">
            Llévate estos 3 Bonos{' '}
            <span className="text-accent-coral" data-id="element-23">GRATIS</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-24">
          {bonuses.map(bonus => <div key={bonus.id} className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100 hover:shadow-xl transition-shadow relative overflow-hidden group flex flex-col items-center text-center" data-id="element-25">
              {/* Ribbon */}
              <div className="absolute top-0 right-0 bg-accent-coral text-white text-xs font-bold px-3 py-1 rounded-bl-lg z-10" data-id="element-26">
                GRATIS
              </div>

              <div className="mb-6 w-full flex justify-center" data-id="element-27">
                <img src={bonus.image} alt={bonus.title} className="h-40 md:h-48 object-contain rounded-md shadow-md group-hover:scale-105 transition-transform duration-300" data-id="element-28" />
              </div>

              <h3 className="text-lg font-bold text-secondary mb-3 leading-tight" data-id="element-29">
                {bonus.title}
              </h3>

              <p className="text-gray-600 text-sm leading-relaxed" data-id="element-30">
                {bonus.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}